<mat-toolbar class="small-bar">
  <span>Device Status</span>
  @if (status) {
    <span class="badge ms-2" [ngClass]="{'text-bg-success': status.online, 'text-bg-dark': !status.online}">
      {{status && status.online ? 'Online' : 'Offline'}}
    </span>
  }
  <span class="toolbar-spacer"></span>
  <button mat-raised-button color="primary" (click)="onClickBtn()" [disabled]="!status || !status.online">Query Device</button>
  <button mat-raised-button color="primary" (click)="onClickPingBtn()" class="ms-2">Ping</button>
</mat-toolbar>
<div class="container-fluid">
  <div class="row mt-2 pb-2">
    @if (status) {
      <div class="col-md-6">
        <mat-card appearance="outlined">
          <app-simple-list [list]="statusData" [title]="device.isDatalogger() ? 'Measurement Logging Status' : 'Meter Status'"></app-simple-list>
        </mat-card>
      </div>
    }
    @if (result) {
      <div class="col-md-6">
        <mat-card appearance="outlined">
          <app-simple-list [list]="queryData" title="Device"></app-simple-list>
          @if (device.isDatalogger()) {
            <mat-list>
              <mat-list-item class="text-center">
                <div class="d-block text-center">
                  <button type="button" mat-raised-button (click)="onClickAdhocBtn()" color="primary">Request an Adhoc upload</button>
                </div>
              </mat-list-item>
            </mat-list>
          }
        </mat-card>
      </div>
    }
  </div>
</div>
